import   React      from "react";
import   classNames from 'classnames';

import   styles     from './TextArea.module.scss';

export interface TextAreaProps {
  classNameGrid?: string;                                                   // classe CSS complémentaire
  placeholder?:   string;                                                   // Le placeholder de l'input
  value?:         string;                                                   // La valeur de l'input
  error?:         string;                                                   // Le message d'erreur
  autocomplete?:  string;                                                   // Se remplit automatiquement
  required?:      boolean | undefined;                                      // Indispensable ou non
  readOnly?:      boolean | undefined;                                      // Editable ou non
  maxLength?:     number;                                                   // Longueur maximale de la saisie
  onChange?:      (event: React.ChangeEvent<HTMLTextAreaElement>) => void;  // Ajout d'une prop pour gérer le changement du textarea
  glowColor?: string;
  width?: string;
  height?: string;
}

export const TextArea = ({ classNameGrid , 
                           placeholder   , 
                           value         , 
                           error         , 
                           autocomplete  ,
                           required      ,
                           readOnly      ,
                           maxLength     ,
                           onChange      ,
                           glowColor     = "var(--color-TextArea-Focus-normal)" ,
                           width         = "100%",
                           height        = "100px", }: TextAreaProps) => {

  const fieldStyle = {
    "--glow-color": glowColor,
  } as React.CSSProperties;

//   var completion = "new-password";
//
//   if ( typeof (autocomplete) == 'string' )
//    {
//     if ( autocomplete === "on" )
//      {
//       completion = "on";
//      }
//    }
   
  return (
           <div className={classNames(styles.root)} style={{ width, height, ...fieldStyle }}>

            <textarea className    = { classNames ( styles.textarea_input ) }
                      placeholder  = { placeholder                          }
                      value        = { value                                }
                      readOnly     = { readOnly                             }
                      maxLength    = { maxLength                            }
                      onChange     = { onChange                             } />
           
           </div>
         );
};

export default TextArea;
